module.exports = __webpack_public_path__ + "static/Print-f9fe5884aa8b053b92dec54ef9f4aa36.jpg";